import { render, staticRenderFns } from "./picture-upload-widget.vue?vue&type=template&id=923f05f6&scoped=true&"
import script from "./picture-upload-widget.vue?vue&type=script&lang=js&"
export * from "./picture-upload-widget.vue?vue&type=script&lang=js&"
import style0 from "./picture-upload-widget.vue?vue&type=style&index=0&id=923f05f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923f05f6",
  null
  
)

export default component.exports